import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './UserProfile.css';

const UserProfile = () => {
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        if (!token) {
          navigate('/login');
          return;
        }

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/users/profile/`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        setProfile(response.data);
      } catch (err) {
        console.error('Error fetching profile:', err);
        setError('Failed to fetch profile data');
      }
    };

    fetchProfile();
  }, [navigate]);

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!profile) {
    return <div>Loading...</div>;
  }

  return (
    <div className="user-profile">
      <h1>Welcome, {profile.user.first_name}!</h1>
      <div className="profile-details">
        <p><strong>Email:</strong> {profile.user.email}</p>
        <p><strong>First Name:</strong> {profile.user.first_name}</p>
        <p><strong>Last Name:</strong> {profile.user.last_name}</p>
        <p><strong>User Type:</strong> {profile.user_type}</p>
        <p><strong>Phone Number:</strong> {profile.phone_number || 'Not provided'}</p>
        {profile.entity && (
          <>
            <h2>Entity Details</h2>
            <p><strong>Name:</strong> {profile.entity.name}</p>
            <p><strong>Description:</strong> {profile.entity.description}</p>
            <p><strong>Active:</strong> {profile.entity.is_active ? 'Yes' : 'No'}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
